import { Component, Event, EventEmitter, getAssetPath, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

import { SupportPremiumLevelId } from '../../../../../utils/enum';
import { InitStore } from '../../../../../utils/Stores/init-store';
import { Store } from '../../../../../utils/Stores/store';

@Component({
  tag: 'contact-mail-success-module',
  styleUrl: 'contact-mail-success-module.scss',
  shadow: true,
})
export class ModuleContactMailSuccess {
  @Event() closeEvent: EventEmitter;
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;
  @Event() getInitEvent: EventEmitter;

  private close() {
    if (Store?.get('is_full')) {
      window.location.href = wcShared?.store?.productsRouting?.website;
    } else {
      this.closeEvent.emit();
    }
  }

  private getPeriod(): string {
    switch (Store?.get('supportPremium').supportLevel) {
      case 2:
        return wcShared?.translate('les 4 prochaines heures');
      case 3:
        return wcShared?.translate('les 2 prochaines heures');
      case 4:
        return wcShared?.translate("l'heure qui suit");
      default:
        return wcShared?.translate('les prochaines 24 heures');
    }
  }

  private goToTickets() {
    this.getInitEvent.emit();
    this.sectionChangeEvent.emit(['tickets']);
  }

  render() {
    return (
      <Host>
        <div class={{ 'mail-success': true, 'mail-success--full': Store?.get('is_full') }}>
          <div class="mail-success-image">
            <img
              src={getAssetPath('./../assets/icons/congrats-ticket.svg')}
              alt={wcShared.translate('Succes')}
            />
          </div>
          <div class="mail-success-title">
            {wcShared?.translate('Votre ticket a bien ete transmis a nos equipes !')}
          </div>
          <div class="mail-success-ticket">
            <div
              class="mail-success-ticket__text2"
              innerHTML={wcShared?.translate(
                'Vous recevrez une reponse dans <span>$period$*</span> sur votre adresse mail $mail$',
                { period: this.getPeriod(), mail: InitStore?.get('init')?.user?.email ?? '' },
              )}
            ></div>
            <div class="mail-success-ticket__terms">*{wcShared?.translate('Heures ouvrees')}</div>
            <div class="mail-success-ticket__text">
              {wcShared?.translate('Numero de ticket :')}
              <span onClick={() => this.goToTickets()}>{Store?.get('contactCode')}</span>
            </div>
            {Store?.get('currentGroup')?.legal_entity_type === 'company' &&
              Store?.get('supportPremium').supportLevel === SupportPremiumLevelId.included && (
                <div class="mail-success-ticket__support-premium-ad">
                  <support-premium-ad-component></support-premium-ad-component>
                </div>
              )}
          </div>
          <div class="mail-success-action">
            <button onClick={() => this.close()}>{wcShared?.translate('Fermer')}</button>
          </div>
        </div>
      </Host>
    );
  }
}
